import { ItemGroup } from '@/experiences/sales-portal/domain/order-guides/blocs/transformers/group-by-item';
import { OrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/types';

/**
 * Based on the dragged item's UUID and the UUID of the visible item adjacent
 * to the drop destination, maps filtered-state item indices to unfiltered-state
 * item indices, so a drag and drop done in the filtered state is correctly
 * applied to the unfiltered state (hidden groups keep their positions). The
 * returned indices follow the REORDER_ITEMS reducer's `moveItem` convention:
 * remove at `fromIndex`, then insert at `toIndex` in the now-shorter array.
 */
export const mapFilteredReorder = (
  fullGroups: ItemGroup<OrderGuideItem>[],
  filteredGroups: ItemGroup<OrderGuideItem>[],
  fromIndex: number,
  toIndex: number,
): { fromIndex: number; toIndex: number } => {
  const draggedGroup = filteredGroups[fromIndex];

  const visibleWithoutMoved = filteredGroups.filter((_, i) => i !== fromIndex);
  // The visible group that ends up directly before the dragged group after the
  // drop; null means it's the top group.
  const precedingGroup = toIndex > 0 ? visibleWithoutMoved[toIndex - 1] : null;

  const fullFrom = fullGroups.findIndex(
    (group) => group.itemUUID === draggedGroup.itemUUID,
  );
  const fullWithoutMoved = fullGroups.filter((_, i) => i !== fullFrom);
  // Insert right after the preceding group, or at the top when nothing precedes it.
  const fullTo = precedingGroup
    ? fullWithoutMoved.findIndex(
        (group) => group.itemUUID === precedingGroup.itemUUID,
      ) + 1
    : 0;

  return { fromIndex: fullFrom, toIndex: fullTo };
};
